import React from 'react';
import PropTypes from 'prop-types';

const GradCapIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 35.466 20.042"
      width="35.47px"
      height="20.04px"
      fill={color}
      role="img"
    >
      <title>Graduation Cap Icon</title>
      <g transform="translate(0 0)">
        <g transform="translate(0 0)">
          <path
            className="a"
            d="M17.515.053a.82.82,0,0,0-.582,0L0,6.4l.955.361L17,12.755a.82.82,0,0,0,.582,0L32.42,7.182a.83.83,0,0,0,0-1.559Z"
            transform="translate(0 0)"
          />
          <path
            className="a"
            d="M16.045,20.488a.413.413,0,0,0-.555.391v4.779c0,2.092,4.605,3.77,10.347,3.77,3.886,0,7.234-.781,9.028-1.914A2.429,2.429,0,0,0,36.2,25.657V20.812a.413.413,0,0,0-.56-.386L25.979,24.04a.4.4,0,0,1-.289,0ZM42.593,16.9a.408.408,0,0,0-.28.338L42.1,18.9l-.711,5.031a.413.413,0,0,0,.41.471h1.861a.413.413,0,0,0,.408-.471l-.942-6.692a.408.408,0,0,0-.537-.333Z"
            transform="translate(-8.611 -9.385)"
          />
        </g>
      </g>
    </svg>
  );
};

export default GradCapIcon;

GradCapIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
